import { Mode } from './enums';
import { INotification } from '../store/notifications/types';
import {
  getNotificationsFromIndexedDB,
  saveNotificationsToIndexedDB,
} from '../utils/indexedDB';

export const LOCAL_STORAGE_TOKEN = 'token';
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refreshToken';
export const LOCAL_STORAGE_PSA = 'psa';
export const LOCAL_STORAGE_THEME_MODE = 'themeMode';
export const LOCAL_STORAGE_IS_NEW_UI = 'isNewUI';
export const LOCAL_STORAGE_SHOW_NEW_UI_MODAL = 'showNewUIModal';
export const LOCAL_STORAGE_TEAMS_CLIENT_TYPE = 'teamsClientType';
export const LOCAL_STORAGE_NOTIFICATIONS = 'notifications';

export const getStorageThemeMode = (): Mode => localStorage.getItem(LOCAL_STORAGE_THEME_MODE) as Mode || Mode.Light
export const setStorageThemeMode = (mode: Mode): void => { localStorage.setItem(LOCAL_STORAGE_THEME_MODE, mode); }
export const getStorageShowNewUIModal = (): boolean => {
  const value = localStorage.getItem(LOCAL_STORAGE_SHOW_NEW_UI_MODAL);

  return !value ? true : value === 'true';
}
export const setStorageShowNewUIModal = (show: boolean): void => { localStorage.setItem(LOCAL_STORAGE_SHOW_NEW_UI_MODAL, String(show)); }

// Get notifications from IndexedDB
export const getStorageNotifications = async (userId: string | null): Promise<INotification[]> => {
  if (!userId) return [];
  return await getNotificationsFromIndexedDB(userId);
};

// Save notifications to IndexedDB
export const setStorageNotifications = async (
  notifications: INotification[],
  userId: string | null,
): Promise<void> => {
  if (!userId) return;
  await saveNotificationsToIndexedDB(notifications, userId);
};
